import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { createSelectOptions } from "../../../../utils/createOptions";

interface IClaimsData {
  claimsCol: number;
  fired: boolean;
  fullName: string;
  id: number;
  role: { [key: string]: string };
  claims: { id: number, name: string }[];
  login: string;
};

const initialState: any = {
  usersCount: null,
  limit: JSON.parse(localStorage.getItem("pageLimit") as string) || 50,
  pages: 1,
  userInputValues: {},
  claimsList: [],
  activeClaimsList: [],
  usersFilters: []
};

export const userListSlice = createSlice({
  name: "usersList",
  initialState,
  reducers: {
    reducerGetUsersList: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.usersCount = action.payload?.count;
      state.pages = action.payload?.pages;
      state.checkboxes = action.payload?.data?.reduce(
        (acc: boolean[], user: IClaimsData) => {
          const userId = user.id;
          acc[userId] = false;
          return acc;
        },
        {}
      );
      state.filtredEmployeesData = action.payload?.data;
    },
    reducerGetAllUsersList: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.usersCount = action.payload?.count;
      state.pages = action.payload?.pages;
      state.checkboxes = action.payload?.data?.reduce(
        (acc: boolean[], user: IClaimsData) => {
          const userId = user.id;
          acc[userId] = false;
          return acc;
        },
        {}
      );
      state.data = action.payload?.data;
    },
    reducerUsersInputValues: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.userInputValues = action.payload;
    },
    reducerUsersStatus: (state: Draft<any>, action: PayloadAction<any>) => {
      state.clientsStatus = action.payload;
    },
    reducerSelectedUserId: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.selectedUserId = action.payload;
    },
    reducerSelectedUser: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.selectedVacancy = action.payload;
    },
    reducerUsersFilters: (state: Draft<any>, action: PayloadAction<any>) => {
      if (action.payload.logins) {
        state.usersFilters = {
          ...state.usersFilters,
          logins: action.payload.logins
        };
      } else if (action.payload.roles) {
        const rolesOptions = action.payload.roles.sort((a: {[key: string]: string}, b: {[key: string]: string}) =>
          Object.values(a).toString().localeCompare(Object.values(b).toString())
        );
        state.usersFilters = {
          ...state.usersFilters,
          roles: createSelectOptions(rolesOptions)
        };
      }
    },
    reducerGetUsersClaims: (state: Draft<any>, action: PayloadAction<any>) => {
      state.claimsList = action.payload;
    },
    reducerUsersClaims: (state: Draft<any>, action: PayloadAction<any>) => {
      state.activeClaimsList = action.payload;
    },
    reducerGetRoles: (state: Draft<any>, action: PayloadAction<any>) => {
      state.rolesList = action.payload;
    },
    reducerClearFilters: (state: Draft<any>) => {
      // return initialState;
      state.userInputValues = {};
    },
  },
});

export const {
  reducerUsersInputValues,
  reducerGetUsersClaims,
  reducerSelectedUserId,
  reducerUsersStatus,
  reducerUsersFilters,
  reducerSelectedUser,
  reducerGetUsersList,
  reducerGetAllUsersList,
  reducerUsersClaims,
  reducerGetRoles,
  reducerClearFilters,
} = userListSlice.actions;

export default userListSlice.reducer;
